import createAnimationWrapper from "./createAnimationWrapper";

const anim = ({x=0,y=0,z=0}) => ({
  "0%": { transform: "translate(0,0)", opacity: 1 },
  "100%": { transform: `translate(${x}, ${y}) rotate(${z})`, opacity: 0 }
});

const Base = createAnimationWrapper(anim, {
  easing: "linear",
  duration: "1s",
  fillMode: "forwards",
});

const Fall = ({to={}, ...props}) => <Base animation={anim(to)} {...props} />;

export default Fall;
